import api from '@/services/api';
import type { ShortCourse, ShortCourseInput } from '@/types/short_course_schema';

const BASE_URL = '/courses/short-courses';

export const shortCourseApi = {
  /**
   * Get all short courses
   */
  getAllShortCourses: async (params?: {
    page?: number;
    per_page?: number;
    search?: string;
    category_id?: string;
    level?: string;
    format?: string;
    status?: string;
    is_featured?: boolean;
  }) => {
    return api.get<{ data: ShortCourse[]; meta?: any }>(BASE_URL, { params });
  },

  /**
   * Get a single short course by ID
   */
  getShortCourseById: async (id: string) => {
    return api.get<{ data: ShortCourse }>(`${BASE_URL}/${id}`);
  },

  /**
   * Create a new short course
   */
  createShortCourse: async (input: ShortCourseInput) => {
    return api.post<{ data: ShortCourse }>(BASE_URL, input);
  },

  /**
   * Update an existing short course
   */
  updateShortCourse: async (id: string, input: Partial<ShortCourseInput>) => {
    return api.put<{ data: ShortCourse }>(`${BASE_URL}/${id}`, input);
  },

  /**
   * Delete/archive a short course
   */
  deleteShortCourse: async (id: string) => {
    return api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Publish a short course
   */
  publishShortCourse: async (id: string) => {
    return api.post<{ data: ShortCourse }>(`${BASE_URL}/${id}/publish`);
  },

  /**
   * Archive a short course
   */
  archiveShortCourse: async (id: string) => {
    return api.post<{ data: ShortCourse }>(`${BASE_URL}/${id}/archive`);
  },
};

export default shortCourseApi;
